import { Box } from "@mui/material";
import React, { useMemo } from "react";
import {
    BLACK_SPLIT_COLORS,
    BOARD_SIZE_PX,
    GRID_SIZE,
    NESTED_BOTTOM_RIGHT,
    NESTED_BOTTOM_RIGHT_COLORS,
    NESTED_TOP_LEFT,
    NESTED_TOP_LEFT_COLORS,
    SUBGRID,
    cellIndex,
} from "./adSlidingLogoBoard.config";
import "./ADSlidingLogoClip.css";

const NESTED_CELLS = new Set([NESTED_TOP_LEFT, NESTED_BOTTOM_RIGHT]);
const BLACK_SPLIT_CELL_SET = new Set([cellIndex(1, 2), cellIndex(2, 1)]);

function NestedSubgrid({ colors }) {
    return (
        <Box className="ad-sliding-logo-subgrid">
            {Array.from({ length: SUBGRID * SUBGRID }, (_, subIndex) => (
                <Box
                    key={`sub-${subIndex}`}
                    className="ad-sliding-logo-subcell"
                    style={{ backgroundColor: colors[subIndex] }}
                />
            ))}
        </Box>
    );
}

/**
 * 512×512: 2×2 grid; color nested at (1,1)(2,2); black 2×2 + white lines at (1,2)(2,1).
 */
export default function ADSlidingLogoPage() {
    const cells = useMemo(() => {
        const list = [];
        for (let i = 0; i < GRID_SIZE * GRID_SIZE; i += 1) {
            if (NESTED_CELLS.has(i)) {
                list.push({
                    key: `nested-${i}`,
                    kind: "nested",
                    colors:
                        i === NESTED_TOP_LEFT
                            ? NESTED_TOP_LEFT_COLORS
                            : NESTED_BOTTOM_RIGHT_COLORS,
                });
            } else if (BLACK_SPLIT_CELL_SET.has(i)) {
                list.push({ key: `black-split-${i}`, kind: "black-split" });
            } else {
                list.push({ key: `cell-${i}`, kind: "tile" });
            }
        }
        return list;
    }, []);

    return (
        <Box className="ad-sliding-logo-root">
            <Box className="ad-sliding-logo-stack">
                <p className="ad-sliding-logo-title">Icon for the iOS and Android apps</p>
                <Box
                    className="ad-sliding-logo-board-wrap"
                    style={{ width: BOARD_SIZE_PX, height: BOARD_SIZE_PX }}
                >
                <Box className="ad-sliding-logo-grid" role="img" aria-label="Sliding puzzle logo preview">
                    {cells.map((cell) => {
                        if (cell.kind === "nested") {
                            return (
                                <Box key={cell.key} className="ad-sliding-logo-cell ad-sliding-logo-cell--nested">
                                    <NestedSubgrid colors={cell.colors} />
                                </Box>
                            );
                        }
                        if (cell.kind === "black-split") {
                            return (
                                <Box key={cell.key} className="ad-sliding-logo-cell ad-sliding-logo-cell--nested">
                                    <NestedSubgrid colors={BLACK_SPLIT_COLORS} />
                                </Box>
                            );
                        }
                        return <Box key={cell.key} className="ad-sliding-logo-cell" />;
                    })}
                </Box>
                </Box>
            </Box>
        </Box>
    );
}
